import React from "react";
import DurationWinRate from "./DurationWinRate.js";
import DurationUtils from "../utils/DurationUtils.js";

export default function StatsByDuration(props) {
  if (props) {
    return (
      <div className="stats-top-civs animate__animated animate__pulse">
        {DurationUtils.durationRanges.map((range) => {
          var stats = props.statsByDuration.filter(
            (stats) => stats.durationRange === range
          );
          var filteredStats = undefined;
          if (stats && stats.length > 0) {
            filteredStats = stats[0];
          }

          var rangeImage = DurationUtils.getDurationImage(range);

          return (
            <DurationWinRate
              key={range}
              statsByDuration={{ range, stats: filteredStats, rangeImage }}
            />
          );
        })}
      </div>
    );
  } else {
    return <div className="stats-top-civs">No stats winrate by duration</div>;
  }
}
